export const initialBarcodeValid = ["02", "25", "75"];
